import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30fec87b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog__header" }
const _hoisted_2 = { class: "dialog__icon" }
const _hoisted_3 = { class: "dialog__body" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: "slide",
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dialog-overlay",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.overlayClicked && _ctx.overlayClicked(...args)), ["self"]))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["dialog", `dialog--${_ctx.className}`])
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_BaseSvg, {
                      class: "icon",
                      icon: `status/${_ctx.className}`
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("header", null, _toDisplayString(_ctx.data.title), 1),
                    _createElementVNode("div", {
                      class: "xhtml",
                      innerHTML: _ctx.data.message
                    }, null, 8, _hoisted_4),
                    (_ctx.data.confirmation)
                      ? (_openBlock(), _createBlock(_component_BaseCheckbox, {
                          key: 0,
                          value: true,
                          id: "confirmation",
                          name: "confirmation",
                          modelValue: _ctx.hasConfirmation,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hasConfirmation) = $event)),
                          label: _ctx.data.confirmation
                        }, null, 8, ["modelValue", "label"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("footer", null, [
                  (_ctx.data?.no)
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false)),
                        class: "no"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.data.no), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BaseButton, {
                    disabled: !_ctx.hasConfirmation,
                    onClick: _withModifiers(_ctx.callBack, ["stop"]),
                    class: _normalizeClass(["yes", `button--${_ctx.className}`])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.data.yes), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick", "class"])
                ])
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}